import React from 'react';
import PropTypes from 'prop-types';
import nanoid from 'nanoid';

export const TAG_FILTERS_NAME = 'Tags';

class NewsFeedTagFilter extends React.Component {
    renderControls() {
        const { config, selectedFilters } = this.props;

        return config.options.map((option) => {
            const id = nanoid();
            return (
                <li className="news-feed-tags-list__li" key={nanoid()}>
                    <div className="news-feed-tag">
                        <input
                            className="news-feed-tag__native visually-hidden"
                            id={id}
                            type="checkbox"
                            value={option.value}
                            checked={selectedFilters.indexOf(option.value) !== -1}
                            onChange={(event) =>
                                this.props.onFiltersChange(
                                    TAG_FILTERS_NAME,
                                    option.value,
                                    event.target.checked
                                )
                            }
                        />
                        <label className="news-feed-tag__label" htmlFor={id}>
                            <span>{option.text}</span>
                            <svg className="news-feed-tag__icon icon" width="10" height="10">
                                <use xlinkHref="#icon-cross"></use>
                            </svg>
                        </label>
                    </div>
                </li>
            );
        });
    }

    render() {
        return (
            <ul className="news-feed-tags-list">
                {this.renderControls()}
            </ul>
        );
    }
}

NewsFeedTagFilter.propTypes = {
    config: PropTypes.object.isRequired,
    selectedFilters: PropTypes.array.isRequired,
    onFiltersChange: PropTypes.func.isRequired
};

export default NewsFeedTagFilter;
